export default __webpack_public_path__ + "static/media/1(2).a2967bee.jpg";